import client from './client';
import { AuthToken } from '../types';

export const login = async (phone: string, password: string): Promise<AuthToken> => {
  const res = await client.post('/api/v1/auth/login', { phone, password });
  return res.data;
};

export const register = async (data: {
  phone: string;
  password: string;
  name: string;
  nickname?: string;
  car_number?: string;
  user_type?: string;
  company_id?: string;
  company_name?: string;
}): Promise<AuthToken> => {
  const res = await client.post('/api/v1/auth/register', data);
  return res.data;
};

export const refresh = async (refreshToken: string): Promise<AuthToken> => {
  const res = await client.post('/api/v1/auth/refresh', { refresh_token: refreshToken });
  return res.data;
};

export const logout = async (): Promise<void> => {
  await client.post('/api/v1/auth/logout');
};

export const forgotPassword = async (
  phone: string,
  newPassword: string,
): Promise<{ message: string }> => {
  const res = await client.post('/api/v1/auth/forgot-password', {
    phone,
    new_password: newPassword,
  });
  return res.data;
};
